import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';
import styled from 'styled-components';

import PaymentTypeIcon from '@/components/elements/PaymentTypeIcon';
import { PAYMENT_METHOD_TITLE } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/ChoosePaymentMethod/hooks';
import { PaymentMethodLabel } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/PaymentMethodLabel';
import { PaymentMethod } from '@/modules/transaction/components/ReimburseMe/types/payment.types';

import { CheckStatus, sectionStatusBackgroundColor, sectionStatusBorderColor } from '../../constants';

interface Props {
  method?: Partial<PaymentMethod>;
  checkStatus?: CheckStatus;
}

const Content = styled(Box)`
  ${({ theme }) => theme.shadows.default};
`;

export const PaymentMethodDetails: React.FC<Props> = ({ method, checkStatus }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box
      width={isMobile ? '100%' : { min: '370px', max: '370px' }}
      pad="spacing12"
      round="container1Round"
      margin={isMobile ? {} : { right: 'spacing32' }}
      background={checkStatus ? sectionStatusBackgroundColor[checkStatus] || 'module' : 'module'}
    >
      <Content
        pad="spacing16"
        round="container1Round"
        background="canvas"
        border={{
          color: checkStatus ? sectionStatusBorderColor[checkStatus] || 'border2' : 'border2',
          size: 'small',
        }}
      >
        <Box
          direction="row"
          align="center"
          border={{ side: 'bottom', color: 'border1', size: 'small' }}
          pad={{ bottom: 'spacing12' }}
          margin={{ bottom: 'spacing12' }}
        >
          <PaymentTypeIcon paymentType={method?.type} />
          <Box pad={{ left: 'spacing12' }}>
            <Text color="textSecondary">Payment Method</Text>
            {method?.type ? (
              <Text color="textBody" size="large" weight={700} data-testId="payment_details_type">
                {t(PAYMENT_METHOD_TITLE[method.type])}
              </Text>
            ) : null}
          </Box>
        </Box>
        <Box>
          <PaymentMethodLabel
            simplifyDesc={!method?.accountNumberLast4}
            paymentMethod={method}
            isVerifiedDateVisible={false}
          />
        </Box>
      </Content>
    </Box>
  );
};
